const React = require('react');

const Container = require('../common/Container.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function CV(props) {
    const artist = props.itemData || {};
    if (!props.builder && Utilities.isNullOrWhitespace(artist.CurriculumVitae)) {
        return null;
    }
    let blockProps = {};
    if (props.config && props.config.Config && props.config.Config.Block) {
        blockProps = props.config.Config.Block;
    }
    const data = props.data || {};
    const style = Utilities.Config.getStyle(data, blockProps, '');
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    <div dangerouslySetInnerHTML={{ __html: artist.CurriculumVitae }} style={style} />
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                Utilities.isNullOrWhitespace(artist.CurriculumVitae) &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    ..._TypeConfig.options.border(),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Artist CV Properties', id: 'cvProps', type: 'header' },
                    ..._TypeConfig.options.text({}, {}, {})
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({}, {}); }
    }
};

module.exports = {
    Component: CV,
    TypeConfig
};